import { median } from "@/lib/stats";

interface Props {
  values: number[];
  max: number;
}

const W = 100;
const H = 24;
const BUCKETS = 16;

/**
 * Tiny histogram + median line. Values are bucketed into BUCKETS evenly-sized bins from 0 to max
 * (max is typically the global P95 across all groups so groups are visually comparable).
 */
export function Sparkline({ values, max }: Props) {
  if (values.length === 0 || max <= 0) return null;

  const counts = new Array<number>(BUCKETS).fill(0);
  for (const v of values) {
    const idx = Math.min(BUCKETS - 1, Math.max(0, Math.floor((v / max) * BUCKETS)));
    counts[idx]! += 1;
  }
  const top = Math.max(...counts) || 1;
  const med = median(values);
  const medX = Math.min(W, (med / max) * W);

  const points = counts.map(
    (c, i) => `${(i / (BUCKETS - 1)) * W},${H - (c / top) * H}`,
  );
  const path = `M0,${H} L${points.join(" L")} L${W},${H} Z`;

  return (
    <svg className="sparkline" viewBox={`0 0 ${W} ${H}`} aria-hidden="true">
      <path d={path} />
      <line className="median" x1={medX} y1={0} x2={medX} y2={H} />
    </svg>
  );
}
